import React from "react";
import { MessageCircle } from "lucide-react";
import settings from "../../constants/settings";
import { trackEvent } from "../../utils/analyticsUtils";
import "./WhatsAppCTA.css";

const WhatsAppCTA = () => (
  <a
    href={settings.wa_consultant_prefilled_link}
    className="whatsapp-help"
    target="_blank"
    rel="noopener noreferrer"
    aria-label="Tanya Admin #PintarPilihKuliah melalui WhatsApp"
    onClick={() => trackEvent("Conversion", "whatsapp_click", "floating")}
  >
    <MessageCircle size={21} aria-hidden="true" />
    <span>Tanya Admin</span>
  </a>
);

export default WhatsAppCTA;
